// removed by extract-text-webpack-plugin
module.exports = {"shippingTitle":"shipping-styles__shippingTitle__641f39c3","returnPolicyCopy":"shipping-styles__returnPolicyCopy__641f39c3"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/shipping-styles.scss
// module id = 1392
// module chunks = 7 16